
import { config } from "../CommonUrl/CommonUrls";
import { public_url } from "../Validations/RegularExpAndVar";
import { CommomLoginAunthenticatePost, CommonAxiosPost, CommonAxiosPut } from "./CommonAxios";

class CommonPost {
  submitLoginPage(req) {
    return CommomLoginAunthenticatePost(config.url.BOC_URL + "auth/authenticate", req,{withCredentials: true});
  }
  submitAnemicStudents(req){
    return CommonAxiosPost(config.url.BOC_URL+"girl-anemic",req);
  }
  submitAnemiaReferred(req){
    return CommonAxiosPost(config.url.BOC_URL+"refer-to-doctor",req);
  }
  AloUpdate(req){
    return CommonAxiosPost(config.url.BOC_URL+"alodtls/insert",req);
  }
  AloEdit(req){
    return CommonAxiosPut(config.url.BOC_URL+"alodtlsedit/edit",req);
  }
  establishmentReg(req){
    return CommomLoginAunthenticatePost(config.url.BOC_URL+public_url+"establishment-registration",req);
  }
  logindetails(req){
    return CommomLoginAunthenticatePost(config.url.BOC_URL+"logindetails",req);
  }
  cessPaymentDetails(req){
  return CommonAxiosPost(config.url.BOC_URL+"cess-collection-transactions",req);
  }
  workerRegistration
  (req){
    return CommomLoginAunthenticatePost(config.url.BOC_URL+"worker-registration",req);
  }
  ALOworkerRegistration
  (req){
    return CommonAxiosPost(config.url.BOC_URL+"worker-registration-alo",req);
  }
  
}
// eslint-disable-next-line import/no-anonymous-default-export
export default new CommonPost();